<script>
import Graphic from "@/components/graphics/Graphic.vue";

export default {
	name: "TestPage",
	components: {Graphic}
}
</script>

<template>
	<div class="test-page">
		<graphic src="https://mathiasbynens.be/demo/animated-webp-supported.webp" :autoplay="true" :loop="true" :is-visible="true"  />
		<graphic src="/test/anim.gif" :autoplay="true" :loop="true" :is-visible="true"  />
		<graphic src="/test/anim.gif" :delay="1" :autoplay="true" :loop="true" :is-visible="true"  />
		<graphic src="/test/anim.gif" :delay="2" :autoplay="true" :loop="true" :is-visible="true"  />
		<graphic src="https://colinbendell.github.io/webperf/animated-gif-decode/3.webp" :delay="5" :autoplay="true" :loop="true" :is-visible="true" width="100" />
		<graphic src="https://ctcdigitalmedia.blob.core.windows.net/medialibrary/2025_D1149/D1149_GIFT_INSPO_01_animate_snowflakeA2.webp" :delay="2" :autoplay="true" :loop="true" :is-visible="true"  />
	</div>
</template>

<style scoped lang="scss">
	.test-page{
	  height: 100vh;
	  overflow: scroll;
	}
</style>
